export function parseAsJSON<T>(res: Response) {
  return res.json() as Promise<T>;
}
